import { terrainPlotsCoords } from './../../e.elements/scenes/Graveyards/config';
import { Point } from '../../elements/AnimationController/scripts/characterAnimator'
import { Object3D, Vector2 } from 'three'
import { CharacterBaseState } from '../CharactersManager/CharactersManager'
import InteractiveTileConfig from '../../e.elements/Grid/scripts/classes/InteractiveTileConfig'
import { TreasureConfig } from '../../f.assets/Characters/scripts/classes/TreasureConfig'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import getGameElementFromObj from '../../e.elements/GameElements/helpers/getGameElementFromObj'

export type TerrainSlice = {
  terrain: {
    data: {
      gridOrigin: Vector2
      grid: InteractiveTileConfig[][]
      isLocked: boolean
      selectedTile: Vector2 | null
      selectedElementUUID: string | null
      // terrainApi?: TerrainApi
      travelPath?: Record<'x' | 'y', number>[]
      treasures: TreasureConfig[]
      gravestones: Vector2[]
    }
    initGrid: (grid: InteractiveTileConfig[][]) => void
    setGridOrigin: (coords: Vector2) => void
    // setTerrainApi: (api: TerrainApi) => void
    setSelectedCoords: (coords: Vector2) => void
    clearSelectedCoords: () => void
    lockInteraction: () => void
    unlockInteraction: () => void
    setTravelPath: (path: Record<'x' | 'y', number>[]) => void
    getSelectedState: () => CharacterBaseState
    getWalkableLandscape: () => number[][]
    calcPath: (
      fromX: number,
      fromY: number,
      toX: number,
      toY: number,
      callback: (path: Vector2[] | null) => void,
    ) => void
    setTreasures: (treasures: TreasureConfig[]) => void
    updateTreasure: (owner: COMMANDERS, data: Partial<TreasureConfig>) => void
    addGravestone: (coords: Vector2) => void
    removeGravestone: (coords: Vector2) => void
    resetTerrain: () => void
  }
}

export class Tile extends Vector2 {
  elementId: string | null
  getGameElement: (uuid: string) => Object3D | undefined
  constructor(x: number, y: number) {
    super(x, y)
    this.elementId = null
    this.getGameElement = useScenesStore.getState().getGameElement
  }
  isEmpty() {
    return this.elementId === null
  }
  isWalkable() {
    // const lots = terrainPlotsCoords.map(c => `${c.x}-${c.y}`)
    // !lots.includes(`${this.x}-${this.y}`)
    const isCandy = this.elementId?.includes('candy_for_')
    return this.isEmpty() || isCandy
  }
  getElementAt(coords: Vector2) {
    const gridElement = this.getGameElement('gridElement')
    return gridElement?.userData.grid[coords.x][coords.y]
  }
  getElement(uuid: string) {
    if (!this.isEmpty) {
      return this.getGameElement(uuid)
    }
  }
  clearTile() {
    this.elementId = null
  }
  setElement(obj: Object3D, coords?: Vector2) {
    const destCoords = coords || (this as Vector2)
    obj.userData.coords = destCoords.clone()
    this.elementId = obj.userData.key ?? obj.uuid
    const gridElement = this.getGameElement('gridElement')
    if (gridElement && gridElement.userData.grid && gridElement.userData.grid[destCoords.x]) {
      gridElement.userData.grid[destCoords.x][destCoords.y] = this
    } else {
      throw new Error('No gridElement, userData.grid or grid[coords.x]')
    }
  }
}
